import React from 'react';
import { IContent, IProduct } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './ProductHighlightElement.scss';
import { cleanSpaces, getProductURL, sendEvent } from '../../../utils';
import PriceContainer from '../../UI/Price/PriceContainer';

// @ts-ignore
import Fade from 'react-reveal/Fade';

interface IProductHighlightElementProps {
  context?: IContent;
  info: any;
  index: number;
  product: IProduct;
}

const ProductHighlightElement = ({ context, info, index, product }: IProductHighlightElementProps) => {
  const { global } = context;
  const { tracking } = info;

  const productId = cleanSpaces(info.product.product_id);

  const buttonClass = product.comingSoon === "Yes" && product.preorder === "false" ? "outline" : product.preorder === "true" ? "preorder" : "buynow";
  const buttonText = product.comingSoon === "Yes" && product.preorder === "false" ? global.learn_more : product.preorder === "true" ? global.preorder : global.buy;

  return (
    <Fade delay={100 * index} duration={600}>
      <div className="element-product_highlight">
        <a
          className="game"
          href={getProductURL(productId, context.config.country_code)}
          onClick={() => sendEvent(tracking)}
        >
          <span
            className="game-image"
            style={{
              backgroundImage: `url(${product.additional_image_link})`
            }}
          />
          <span className="game-title">
            {product.short_title || product.title}
          </span>
          <span className="game-edition">
            {product.Edition}
          </span>
          {product.comingSoon === "Yes" ? (
            <span className="coming-soon-title">{global.coming_soon}</span>
          ) : (
            <span className="game-price">
              <PriceContainer product={product} />
            </span>
          )}
          <span className="game-link">
            <span
              className={buttonClass}
              data-alt-text={buttonText}
            >
              <span>{buttonText}</span>
            </span>
          </span>
        </a>
      </div>
    </Fade>
  );
};

export default withContent(ProductHighlightElement);
